<template>
  <CDropdown
    in-nav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <img
            v-if="account.image_url"
            :src="account.image_url"
            class="c-avatar-img"
          />
          <img v-else src="@/assets/avatar_default.png" class="c-avatar-img" />
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>{{ $t("label.account") }}</strong>
    </CDropdownHeader>
    <CDropdownItem @click="showModal">
      <CIcon name="cil-lock-locked" />{{
        $t("label.label_title_change_password")
      }}
    </CDropdownItem>
    <CDropdownItem @click.prevent="handleLogout">
      <CIcon name="cil-account-logout" />{{ $t("label.logout") }}
    </CDropdownItem>
    <template>
      <b-modal ref="my-modal" hide-footer hide-header>
        <ValidationObserver ref="formResignation" v-slot="{ handleSubmit }">
          <CForm @submit.prevent="handleSubmit(handleChangePassword)">
            <CRow>
              <CCol md="12" class="form-field">
                <label>{{ $t("reset_password.password_old") }}</label>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('reset_password.password_old')"
                >
                  <b-form-input
                    type="password"
                    v-model="formChangePassword.password"
                    :placeholder="$t('reset_password.password_old')"
                  />
                  <span class="required">{{ errors[0] }}</span>
                </ValidationProvider>
              </CCol>
            </CRow>
            <br />
            <CRow>
              <CCol md="12" class="form-field">
                <label>{{ $t("reset_password.password_new") }}</label>
                <ValidationProvider
                  rules="required|min:6"
                  v-slot="{ errors }"
                  :name="$t('reset_password.password_new')"
                >
                  <b-form-input
                    type="password"
                    v-model="formChangePassword.passwordNew"
                    :placeholder="$t('reset_password.password_new')"
                  />
                  <span class="required">{{ errors[0] }}</span>
                </ValidationProvider>
              </CCol>
            </CRow>
            <br />
            <CRow>
              <CCol md="12" class="form-field">
                <label>{{ $t("reset_password.password_confirm") }}</label>
                <ValidationProvider
                  :rules="{
                    required: true,
                    confirmed: $t('reset_password.password_new')
                  }"
                  v-slot="{ errors }"
                  :name="$t('reset_password.password_confirm')"
                >
                  <b-form-input
                    type="password"
                    v-model="formChangePassword.confirmPassword"
                    :placeholder="$t('reset_password.password_confirm')"
                  />
                  <span class="required">{{ errors[0] }}</span>
                </ValidationProvider>
              </CCol>
            </CRow>
            <CRow class="d-flex justify-content-end mr-1">
              <b-button type="submit" class="btn btn-success mt-3">{{
                $t("button.label_action_accept")
              }}</b-button>
              <span class="mr-2"></span>
              <b-button class="mt-3" variant="outline-danger" @click="hideModal"
                >{{ $t("button.label_action_cancel") }}
              </b-button>
            </CRow>
          </CForm>
        </ValidationObserver>
      </b-modal>
    </template>
  </CDropdown>
</template>

<script>
import "sweetalert2/src/sweetalert2.scss";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "TheHeaderDropdownAccnt",
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    avatar: String
  },
  computed: {
    ...mapGetters({
      account: "auth/account"
    })
  },
  data() {
    return {
      formChangePassword: {
        password: null,
        passwordNew: null,
        confirmPassword: null
      }
    };
  },
  methods: {
    ...mapActions("layout", ["setLoading"]),
    showModal() {
      this.formChangePassword = {};
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    handleLogout() {
      this.$emit("handleLogout");
    },
    handleRefreshToken() {
      this.$emit("handleRefreshToken");
    },
    async handleChangePassword() {
      this.setLoading(true);
      await this.$store
        .dispatch("auth/changePassword", this.formChangePassword)
        .then(() => {
          this.$toast(
            this.$t("popup.label_change_password_success"),
            this.$t("popup.label_title_change_password"),
            2000,
            "b-toaster-top-center",
            "success"
          );
          this.hideModal();
          this.$router.push({ name: "Login" });
          this.formChangePassword = {};
          this.setLoading(false);
        })
        .catch(() => {
          this.setLoading(false);
        });
    }
  }
};
</script>

<style scoped>
.c-icon {
  margin-right: 0.3rem;
}
</style>
